import axios from 'axios';

const host = 'https://public.orderonline.id';
const endpoint = '/file';

export default {
	// Upload
	upload(params, cb, errorCb, progressCallback) {
		const url = `${host}${endpoint}`;
		const config = {
			onUploadProgress: (progressEvent) => {
				const percentCompleted = Math.floor((progressEvent.loaded * 100) / progressEvent.total);
				if (progressCallback) progressCallback(percentCompleted);
			},
		};
		axios.post(url, params, config)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	// Remove
	remove(filename, cb, errorCb) {
		const params = {
			filename,
		};
		const url = `${host}${endpoint}`;
		axios.delete(url, { data: params })
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},
};
